import * as React from "react";
import {
  Modal,
  Typography,
  Box,
  Button,
  Avatar,
  CircularProgress,
  Chip,
  Paper,
  MenuItem,
} from "@mui/material";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { notification } from "antd";
import {
  centered_flex_box,
  MainInput,
} from "../../../app/components/Styles";
import { generateWhatsappCampaignInvitations } from "../../../app/store/actions/adminActions";
import ReactFileReader from "react-file-reader";
import Upload from "@mui/icons-material/Upload";
import Download from "@mui/icons-material/Download";
import CampaignIcon from "@mui/icons-material/Campaign";
import download from "downloadjs";
import * as XLSX from 'xlsx';
import { motion } from "framer-motion";

export const GenerateCampaignInvitationModal = ({
  open,
  handleClose,
  wait,
  generateWhatsappCampaignInvitations
}) => {
  const [file, setFile] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [sendFrom, setSendFrom] = React.useState("613423768526503");
  const { id } = useParams();

  const handleDeleteFile = () => {
    setFile(null);
    setData([])
  };

  const handleFiles = (files) => {
    const newFile = files[0];
    setFile(newFile);
    var reader = new FileReader();
    reader.readAsArrayBuffer(newFile);
    reader.onload = async (e) => {
      try {
        const buf = new Uint8Array(e.target.result);
        const workbook = XLSX.read(buf, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet, {
          raw: false,
          defval: '',
          blankrows: false
        });
        const d = jsonData.filter(
          (info) => info.name && info.name.trim() !== "" && info.phoneNumber && info.phoneNumber.trim() !== ""
        );
        setData(d);
      } catch (err) {
        console.error('Error processing file:', err);
        notification.error({ message: "Error processing Excel file. Please check the file format." });
      }
    };
  };

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const handleSubmit = async () => {
    if (file) {
      const info = {
        campaignId: id,
        data,
        sendFrom,
      };
      generateWhatsappCampaignInvitations(info, handleClose)
      await timeout(500);
    } else {
      notification.error({ message: "Please Upload a valid .csv file" });
    }
  };

  return (
    <Modal 
      open={open} 
      onClose={handleClose}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(4px)'
        }
      }}
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '90vw', sm: '600px' },
        maxWidth: '90vw',
        maxHeight: '90vh',
        outline: 'none'
      }}>
        {wait.isLoading && (
          <Paper
            elevation={8}
            sx={{
              ...centered_flex_box,
              minHeight: "50vh",
              p: 4,
              borderRadius: 3,
              backgroundColor: 'var(--platform-surface)',
              border: '1px solid #e0e0e0'
            }}
          >
            <CircularProgress 
              size={60}
              sx={{ 
                color: "var(--primaryPurple)",
                mb: 2
              }} 
            />
            <Typography 
              variant="h6" 
              sx={{ 
                color: "var(--primaryPurple)",
                fontFamily: 'TickitOne, Helvetica, Arial, sans-serif'
              }}
            >
              Generating invitations...
            </Typography>
          </Paper>
        )}
        {!wait.isLoading && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <Paper
              elevation={12}
              sx={{
                p: 5,
                borderRadius: 4,
                backgroundColor: 'var(--platform-surface)',
                border: '1px solid #e0e0e0',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                maxHeight: '90vh',
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                  width: '6px'
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: '#f1f1f1',
                  borderRadius: '3px'
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'var(--primaryPurple)',
                  borderRadius: '3px'
                }
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Avatar
                  sx={{
                    m: 2,
                    bgcolor: "var(--primaryPurple)",
                    width: 80,
                    height: 80,
                    boxShadow: '0 8px 24px rgba(95, 53, 184, 0.3)',
                    '& .MuiSvgIcon-root': {
                      fontSize: '2.5rem',
                      color: 'white'
                    }
                  }}
                >
                  <CampaignIcon />
                </Avatar>
                <Typography 
                  component="h1" 
                  variant="h4" 
                  sx={{ 
                    mb: 4,
                    color: 'var(--primaryPurple)',
                    fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                    fontWeight: 'bold',
                    textAlign: 'center'
                  }}
                >
                  Generate Campaign Invitations
                </Typography>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    mb: 3,
                    color: 'var(--tickit-gray500)',
                    fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                    textAlign: 'center',
                    maxWidth: '400px'
                  }}
                >
                  Upload an Excel file with invitee data to send WhatsApp invitations
                </Typography>

                <Button
                  fullWidth
                  variant="outlined"
                  size="large"
                  startIcon={<Download />}
                  onClick={() =>
                    download(
                      "https://tickit-media.s3.eu-central-1.amazonaws.com/files/tickets-sample.xlsx"
                    )
                  }
                  sx={{
                    mb: 3,
                    borderRadius: 3,
                    py: 1.5,
                    textTransform: 'none',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    borderColor: '#e0e0e0',
                    color: 'var(--tickit-gray500)',
                    fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                    '&:hover': {
                      borderColor: 'var(--primaryPurple)',
                      backgroundColor: 'rgba(95, 53, 184, 0.04)',
                      color: 'var(--primaryPurple)'
                    }
                  }}
                >
                  Download Excel Sample
                </Button>

                <Box sx={{ width: '100%', mt: 2 }}>
                  <MainInput
                    margin="normal"
                    autoFocus
                    fullWidth
                    select
                    id="sendFrom"
                    label="Send From Mobile Number"
                    name="sendFrom"
                    value={sendFrom}
                    onChange={({ target }) => setSendFrom(target.value)}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: { sx: { bgcolor: 'var(--platform-surface)', color: 'var(--primaryPurple)' } },
                      },
                    }}
                    sx={{
                      mb: 3,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        backgroundColor: 'var(--platform-surface)',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'var(--primaryPurple)',
                          borderWidth: '2px'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'var(--primaryPurple)',
                          borderWidth: '2px'
                        }
                      },
                      '& .MuiInputLabel-root': {
                        color: 'var(--primaryPurple)',
                        fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                      }
                    }}
                  >
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="122093470430020670">
                      +20 10 60414359 
                    </MenuItem>
                    <MenuItem sx={{ color: 'var(--primaryPurple)' }} value="613423768526503">
                      +20 10 27603244 (Main)
                    </MenuItem>
                  </MainInput>

                  <Box sx={{ mt: 2, mb: 3 }}>
                    <ReactFileReader handleFiles={handleFiles} fileTypes={[".xlsx", ".xls"]}>
                      <Button
                        fullWidth
                        variant="outlined"
                        size="large"
                        startIcon={<Upload />}
                        sx={{
                          borderRadius: 3,
                          py: 1.5,
                          textTransform: 'none',
                          fontSize: '1rem',
                          fontWeight: 'bold',
                          borderColor: '#e0e0e0',
                          color: 'var(--tickit-gray500)',
                          fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                          '&:hover': {
                            borderColor: 'var(--primaryPurple)',
                            backgroundColor: 'rgba(95, 53, 184, 0.04)',
                            color: 'var(--primaryPurple)'
                          }
                        }}
                      >
                        Upload Excel File
                      </Button>
                    </ReactFileReader>
                    {file && (
                      <Chip
                        label={file.name}
                        onDelete={handleDeleteFile}
                        sx={{
                          mt: 2,
                          borderRadius: 2,
                          backgroundColor: 'rgba(95, 53, 184, 0.1)',
                          color: 'var(--primaryPurple)',
                          fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif',
                          '& .MuiChip-deleteIcon': {
                            color: 'var(--primaryPurple)',
                            '&:hover': {
                              color: 'var(--secPurple)'
                            }
                          }
                        }}
                      />
                    )}
                  </Box>

                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: 3,
                    mt: 4,
                    pt: 3,
                    borderTop: '1px solid #e0e0e0'
                  }}>
                    <Button
                      onClick={handleClose}
                      variant="outlined"
                      size="large"
                      sx={{
                        borderRadius: 3,
                        px: 4,
                        py: 1.5,
                        textTransform: 'none',
                        fontSize: '1.1rem',
                        fontWeight: 'bold',
                        borderColor: '#e0e0e0',
                        color: 'var(--tickit-gray500)',
                        fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                        '&:hover': {
                          borderColor: '#e0e0e0',
                          backgroundColor: '#f5f5f5',
                          color: '#333'
                        }
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleSubmit}
                      variant="contained"
                      size="large"
                      disabled={!file}
                      sx={{
                        borderRadius: 3,
                        px: 4,
                        py: 1.5,
                        textTransform: 'none',
                        fontSize: '1.1rem',
                        fontWeight: 'bold',
                        backgroundColor: 'var(--primaryPurple)',
                        fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                        boxShadow: '0 4px 16px rgba(95, 53, 184, 0.3)',
                        '&:hover': {
                          backgroundColor: 'var(--secPurple)',
                          boxShadow: '0 6px 20px rgba(95, 53, 184, 0.4)',
                          transform: 'translateY(-2px)'
                        },
                        '&:disabled': {
                          backgroundColor: '#e4e0eb',
                          color: 'var(--tickit-gray500)'
                        },
                        transition: 'all 0.3s ease'
                      }}
                    >
                      Send Invitations
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </motion.div>
        )}
      </Box>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  wait: state?.wait,
});

const mapDispatchToProps = { generateWhatsappCampaignInvitations };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GenerateCampaignInvitationModal);


